import React from 'react';

const IconAdd = (props) => {
  const { color, style, onClick } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={37}
      height={37}
      fill="none"
      style={style}
      onClick={onClick}
    >
      <g filter="url(#a)">
        <path
          fill="#fff"
          stroke={color}
          strokeWidth={1.003}
          d="M18.5.5a16 16 0 1 1 0 32 16 16 0 0 1 0-32Z"
        />
      </g>
      <path
        stroke={color}
        strokeMiterlimit={10}
        strokeWidth={2.4}
        d="M18.5 10.184v12.63M12.184 16.5h12.63"
      />
      <defs>
        <filter
          id="a"
          width={37}
          height={37}
          x={0}
          y={0}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.239 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7038_15056"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_7038_15056"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

IconAdd.propTypes = {};

export default IconAdd;
